import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, XCircle } from 'lucide-react';
const forWho = ['Personas que sufren de pesadez abdominal después de cada comida.', 'Quienes tienen un evento importante mañana y no les cierra el pantalón o el vestido.', 'Profesionales que viven con estrés y notan que su digestión se detiene por completo.', "Cualquiera que esté cansado de verse 'hinchado' a pesar de intentar comer sano."];
const notForWho = ['Personas que buscan una solución mágica para perder 10kg de grasa en un día (esto es para inflamación).', 'Quienes no estén dispuestos a seguir un plan sencillo de 24 horas.'];
export function WhoIsItFor() {
  return <section className="py-16 md:py-24 px-4 bg-white" data-id="element-174">
      <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-8" data-id="element-175">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="bg-forest-50 p-8 rounded-3xl border border-forest-100" data-id="element-176">
          <h3 className="text-2xl font-bold text-forest mb-6 flex items-center gap-3" data-id="element-177">
            <CheckCircle className="w-8 h-8 text-forest" data-id="element-178" />
            Esto ES para ti si...
          </h3>
          <ul className="space-y-4" data-id="element-179">
            {forWho.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-180">
                <div className="w-2 h-2 rounded-full bg-forest mt-2.5 shrink-0" data-id="element-181"></div>
                <span className="text-charcoal leading-relaxed" data-id="element-182">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-orange-light/30 p-8 rounded-3xl border border-orange-light" data-id="element-183">
          <h3 className="text-2xl font-bold text-orange mb-6 flex items-center gap-3" data-id="element-184">
            <XCircle className="w-8 h-8 text-orange" data-id="element-185" />
            Esto NO es para ti si...
          </h3>
          <ul className="space-y-4" data-id="element-186">
            {notForWho.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-187">
                <div className="w-2 h-2 rounded-full bg-orange mt-2.5 shrink-0" data-id="element-188"></div>
                <span className="text-charcoal leading-relaxed" data-id="element-189">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}